export default () => {
  const meta = <HTMLMetaElement>document.querySelector('meta[name="viewport"]');
  meta.content = meta.content.split(',').filter((part) => {
    return !part.match('/height/');
  }).concat(`height=${window.visualViewport ? visualViewport.height : window.innerHeight}`).join(', ')
}